import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'timezoneConverter'
})
export class TimezoneConverterPipe implements PipeTransform {

  transform(utcDate: string | Date | null, timezone: string | null): string {
    if (!utcDate) {
      return ''; // Default message if no date
    }

    let utcMoment = utcDate instanceof Date ? moment.utc(utcDate) : moment.utc(utcDate);

    if (timezone) {
      try {
        const localizedMoment = utcMoment.tz(timezone);
        const formattedDate = localizedMoment.format('MM-DD-YYYY'); // Adjust format as needed
        let abbreviation = localizedMoment.format('z'); // Get the timezone abbreviation

        // Check if abbreviation is a number (e.g., "+7") and replace it with the timezone name
        if (!abbreviation || !isNaN(+abbreviation)) {
          abbreviation = timezone;
        }

        return `${formattedDate} (${abbreviation})`;
      } catch (error) {
        return utcMoment.format('MM-DD-YYYY') + " (UTC)";
      }
    } 

    // If no timezone is provided, default to UTC
    return utcMoment.format('MM-DD-YYYY') + " (UTC)";
  }
}
@Pipe({
  name: 'timezoneDate'
})
export class TimezoneDatePipe implements PipeTransform {

    transform(backendDate: string | null, targetTimezone: string | null): string {
      if (!backendDate) return '';

      const backendTimezone = 'America/Los_Angeles'; // set this to your backend timezone

      try {
        // Tell moment the input is in backend's timezone
        const backendMoment = moment.tz(backendDate, 'YYYY-MM-DD HH:mm:ss', backendTimezone);

        if (targetTimezone) {
          return backendMoment.clone().tz(targetTimezone).format('MM-DD-YYYY HH:mm');
        }

        // Default: return in local browser time
        return backendMoment.local().format('MM-DD-YYYY HH:mm');
      } catch (error) {
        return backendDate.toString(); // fallback
      }
    
    }
}